import axios, { AxiosInstance } from 'axios';
import { RESPONSE_CODES, STALE_TIME } from '../utils/enum_constants/api';
import { Flows } from '../utils/enum_constants/decision';
import { setShow403Dialog } from '../redux/reducer/forbiddenDetectorReducer';
import { startRequest, endRequest } from '../redux/reducer/loadingReducer';
import { useDispatch } from 'react-redux';
import { store } from '../redux/Store';
// import authUser from '../utils/helpers/authUser';
import { logErrorToDB } from '../utils/helpers/logErrorToDb';
import qs from 'qs';
type AxiosAdapterProperties = {
  baseUrl: string;
  isAuth?: boolean;
  isMultipart?: boolean;
  token?: string;
};

const http = ({
  baseUrl,
  isAuth = false,
  // isMultipart = false,
}: AxiosAdapterProperties) => {
  const getAxiosInstance: AxiosInstance = axios?.create({
    baseURL: baseUrl,
    timeout: STALE_TIME,
    withCredentials: true,
    headers: {
      Accept: 'application/json',
      'Content-Type': isAuth
        ? 'application/x-www-form-urlencoded'
        : 'application/json;charset=UTF-8',
    },
  });

  getAxiosInstance.interceptors.request.use(
    async (request) => {
      // if (request?.headers && jwtToken) {
      // request.headers.Authorization = `Bearer ${jwtToken}`;
      // }
      store.dispatch(startRequest());
      return request;
    },
    (error) => {
      store.dispatch(endRequest());
      return Promise.reject(error);
    }
  );

  getAxiosInstance?.interceptors?.response?.use(
    (response) => {
      store.dispatch(endRequest());
      return response;
    },
    (error) => {
      store.dispatch(endRequest());
      const requestUrl = error?.config?.url;
      const fullUrl = `${error?.config?.baseURL}${error?.config?.url}?${qs.stringify(error?.config?.params)}`;
      const data = error?.config?.data;
      logErrorToDB(error, { requestUrl, data });
      if (error.response && error.response.status === 403) {
        store.dispatch(setShow403Dialog(true));
      } else {
        return Promise.reject(error);
      }
    }
  );

  return getAxiosInstance;
};

export default http;
